import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  selectedQuizOptions,
  deselectedQuizOptions,
} from "@features/quizzes/quizzesSlice";

const QuizItem = ({ quiz, questionId, i }) => {
  const { question, options } = quiz || {};

  const [answers, setAnswers] = useState({});

  const dispatch = useDispatch();

  const handleChange = (e, answerId) => {
    if (e.target.checked) {
      setAnswers({ ...answers, [questionId]: answerId });
      dispatch(selectedQuizOptions({ ...answers, [questionId]: answerId }));
    } else {
      setAnswers({ ...answers, [questionId]: null });
      dispatch(deselectedQuizOptions({ key: questionId, value: answerId }));
    }
  };

  return (
    <div className="quiz">
      <h4 className="question">Quiz 1 - {question}</h4>
      <form className="quizOptions">
        {options?.map((option, j) => (
          <label key={option.id} htmlFor={`option${i + 1}_q${j + 1}`}>
            <input
              type="checkbox"
              name={`option${i + 1}`}
              id={`option${i + 1}_q${j + 1}`}
              value={option.option}
              onChange={(e) => handleChange(e, option.id)}
            />
            {option.option}
          </label>
        ))}
      </form>
    </div>
  );
};

export default QuizItem;
